import { INITIAL_STATE } from "./InitialState";
import {
  LOGIN_SAGA,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGIN_CLEAR,
  RECOVER_PASWORD_SAGA,
  RECOVER_PASWORD_SUCCESS,
  RECOVER_PASWORD_FAILURE,
  LOGOUT_SAGA,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
} from "./Action";

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Login
    case LOGIN_SAGA:
      return onLoginInit(state);
    case LOGIN_SUCCESS:
      return onLoginSuccess(state, action.payload);
    case LOGIN_FAILURE:
      return onLoginFailure(state, action.payload);
    case LOGIN_CLEAR:
      return onLoginClear(state);
    // Recover password
    case RECOVER_PASWORD_SAGA:
      return onRecoverPaswordInit(state);
    case RECOVER_PASWORD_SUCCESS:
      return onRecoverPaswordSuccess(state);
    case RECOVER_PASWORD_FAILURE:
      return onRecoverPaswordFailure(state, action.payload);
    // Logout
    case LOGOUT_SAGA:
      return onLogoutInit(state);
    case LOGOUT_SUCCESS:
      return onLogoutSuccess(state);
    case LOGOUT_FAILURE:
      return onLogoutFailure(state, action.payload);
    default:
      return state;
  }
};

// Login
const onLoginInit = (state) => {
  return {
    ...state,
    isLoginLoading: true,
    loginError: "",
  };
};

const onLoginSuccess = (state, payload) => {
  return {
    ...state,
    isLoginLoading: false,
    loginError: "",
    isLoggedin: true,
    userName: payload.name,
  };
};

const onLoginFailure = (state, payload) => {
  return {
    ...state,
    isLoginLoading: false,
    loginError: payload.errorMessage,
  };
};

const onLoginClear = (state) => {
  return {
    ...state,
    isLoginLoading: false,
    loginError: "",
  };
};

// Recover password
const onRecoverPaswordInit = (state) => {
  return {
    ...state,
    isRecoverPasswordLoading: true,
    recoverPasswordError: "",
  };
};

const onRecoverPaswordSuccess = (state) => {
  return {
    ...state,
    isRecoverPasswordLoading: false,
    recoverPasswordError: "",
  };
};

const onRecoverPaswordFailure = (state, payload) => {
  return {
    ...state,
    isRecoverPasswordLoading: false,
    recoverPasswordError: payload.errorMessage,
  };
};

// Logout
const onLogoutInit = (state) => {
  return {
    ...state,
    isLogoutLoading: true,
    logoutError: "",
  };
};

const onLogoutSuccess = (state) => {
  return {
    ...state,
    ...INITIAL_STATE,
  };
};

const onLogoutFailure = (state, payload) => {
  return {
    ...state,
    isLogoutLoading: false,
    logoutError: payload.errorMessage,
  };
};

export default reducer;



// WEBPACK FOOTER //
// ./src/stores/Login/Reducer.js